import React from "react";
import { Link } from "react-router";

export default function FAQPage() {
  window.scroll(0, 0);
  return (
    <main className="site--width">
      <div className="faqPage">
        <h2>Frequently Asked Questions</h2>
        <h3>How do I join MedCafe?</h3>
        <p>
          To join MedCafe, click <Link to="/users/sign_up">Sign Up</Link> and
          complete the registration process.
          <br />
          If you are a GP, GP trainee, Consultant, or Hospital Doctor, please
          enter your Medical Council number.
          <br />
          If you are a General Practice Nurse, Advanced Nurse Practitioner, or
          an Allied Healthcare Professional, please enter your accreditation
          number.
          <br />
          We will send you an email to verify your account.
          <br />
          Click on the link in the email to verify your account.
        </p>
        <h3>I didn’t receive a verification email.</h3>
        <p>
          Sometimes this verification email arrives to your Junk, Spam or
          Promotion folder. When you find it, please mark it as{" "}
          <strong>Not Spam</strong> or <strong>Important</strong> so that you
          receive emails from us about future meetings.
          <br />
          If this verification email does not appear in any of your email
          folders, please email us at{" "}
          <a href="mailto:support@medcafe.ie">support@medcafe.ie</a>.
        </p>
        <h3>I forgot my password.</h3>
        <p>
          To reset your password, please visit the{" "}
          <Link to="/users/sign_in">Log In</Link> page and click{" "}
          <Link to="/users/forgot_password">Forgot Password</Link>. After you
          submit your details, we will send you an email with a link to reset
          your password. If you cannot find this Forgot Password email, please
          follow the steps as outlined above.
          <br />
          Should you have any issues with resetting your password, please email
          us at <a href="mailto:support@medcafe.ie">support@medcafe.ie</a>.
        </p>
        <h3>Can I get an email reminder before a meeting?</h3>
        <p>
          Yes. Click the <strong>Register</strong> button next to the meeting
          that you would like to attend. We will then send you a reminder email
          24 hours prior to the meeting. All MedCafe users get an email reminder
          1 hour before each meeting. If you register for a live meeting and are
          unable to attend, we will also send you a notification email once the
          recording is available to watch on MedCafe.
        </p>
        <h3>How do I join a meeting?</h3>
        <p>
          At the meeting’s scheduled start time, please log into your MedCafe
          account. You will see the meeting under the{" "}
          <strong>Current Webinars</strong> tab. Click the "Join Webinar"
          button. The meeting will open for you via the Zoom platform.
          <br />
          If you are unable to join the meeting after the scheduled start time,
          please email us at{" "}
          <a href="mailto:support@medcafe.ie">support@medcafe.ie</a>.
        </p>
        <h3>I missed a live meeting. Will it be recorded?</h3>
        <p>
          Most live meetings hosted on MedCafe are recorded and edited for
          clarity. This can take some time, and we appreciate your patience
          while we get this ready for you.
          <br />
          When the recording is ready, we will publish it to the Recorded
          section of MedCafe where it will be available to watch for 6 months.
          <br />
          If you register for a meeting, we will send you a notification email
          when the recording has been published.
        </p>
        <h3>How do I know if a meeting is eligible for CPD?</h3>
        <p>
          To see if a meeting is eligible for CPD, please find the CPD Status to
          the right of the meeting listing.
          <br />
          <strong>CPD Points: Applied For</strong>
          We have applied for CPD and are awaiting approval from the ICGP.
          <br />
          <strong>CPD Points: Not Eligible</strong>
          This meeting is not eligible for CPD accreditation.
          <br />
          <strong>CPD Points: Granted</strong>
          This meeting has been granted CPD approval
        </p>
        <h3>I attended a meeting live but cannot find my CPD certificate.</h3>
        <p>
          A summary of meetings that you have attended can be found in your{" "}
          <Link to="/cpd">CPD Locker</Link>. Please select{" "}
          <Link to="/cpd/live">Webinars Attended – Live</Link> and also the
          year.
          <br />
          Please click the PDF symbol to view and download your CPD Certificate.
          <br />
          If you see <strong>CPD Points: Applied For</strong>, we have applied
          for CPD and are awaiting approval from the ICGP. We will send you a
          notification email once your CPD certificate is available to download.
        </p>
        <h3>
          I watched a webinar recording but cannot find my CPD certificate.
        </h3>
        <p>
          A summary of meetings that you have watched can be found in your{" "}
          <Link to="/cpd">CPD Locker</Link>. Please select{" "}
          <Link to="/cpd/recorded">Webinars Viewed – Recorded</Link> and also
          the year. When you watch a recording, you must complete a 10 question
          true/false quiz and score 8/10 or more to unlock your certificate.
          Please click <strong>Take CPD Quiz</strong> to complete this quiz.
          <br />
          Please click the PDF symbol to view and download your CPD Certificate.
          <br />
          If you see <strong>CPD Points: Applied For</strong>, we have applied
          for CPD and are awaiting approval from the ICGP. We will send you a
          notification email once your CPD certificate is available to download.
        </p>
        <div className="faqPage__line" />
        <p>
          If you have any questions, please email us at{" "}
          <a href="mailto:support@medcafe.ie">support@medcafe.ie</a> for
          assistance.
        </p>
      </div>
    </main>
  );
}



// WEBPACK FOOTER //
// ./src/components/FAQ/FaqPage.js